import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../../features/components/Forms/StepForm/Step'
import Field from '../../../../../../../../components/Form/Field'
import CpaAdvancedSettings from '../CpaAdvancedSettings'

import { OPTIMIZATION_GOAL } from '../../../fields'
import {
  CLICK,
  ENGAGED_VIEW,
  ENGAGED_VIEW_FIFTEEN,
  FOLLOWERS,
  PROFILE_VIEWS,
  TRAFFIC_LANDING_PAGE_VIEW
} from '../../../optimizationGoalOptions'
import { ENGAGEMENT, TRAFFIC, VIDEO_VIEWS } from '../../../../../../../../constants/campaigns'
import { BID_PRICE } from '../../../../../../LineItemForms/LineItemTikTokCreate/LineItemTikTokCreateForm/fields'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

const stepFields = [BID_PRICE]

const campaignObjectiveTrafficOptions = [
  {
    value: CLICK,
    label: 'Click'
  },
  {
    value: TRAFFIC_LANDING_PAGE_VIEW,
    label: 'Landing page view'
  }
]

const campaignObjectiveVideoViewsOptions = [
  {
    value: ENGAGED_VIEW,
    label: '6s Views'
  },
  {
    value: ENGAGED_VIEW_FIFTEEN,
    label: '15s Views'
  }
]

const campaignObjectiveVideoViewsEngagement = [
  {
    value: FOLLOWERS,
    label: 'Followers'
  },
  {
    value: PROFILE_VIEWS,
    label: 'Profile views'
  }
]

const OptimizationGoalAndBiddingStep = ({
  formik,
  handleStepChange,
  campaignObjective,
  showBidField,
  shouldPopulateExistingValues
}) => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()

  const options = useMemo(() => {
    switch (campaignObjective.toLowerCase()) {
      case TRAFFIC:
        return campaignObjectiveTrafficOptions
      case VIDEO_VIEWS:
        return campaignObjectiveVideoViewsOptions
      case ENGAGEMENT:
      default:
        return campaignObjectiveVideoViewsEngagement
    }
  }, [campaignObjective])

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  if (!shouldPopulateExistingValues) {
    return (
      <Step stepTitle="Optimisation goal and bidding" handleContinue={handleContinue}>
        <section className={drawerFormClasses.section}>
          <div className={drawerFormClasses.sectionTitle}>{t('Optimisation goal')}</div>
          <p>{t('Select the optimisation goal for this ad set')}</p>

          <Field name={OPTIMIZATION_GOAL} formik={formik} options={options} placeholder={t('Optimisation goal')} />
        </section>
        {showBidField && (
          <CpaAdvancedSettings formik={formik} goalOptions={options} campaignObjective={campaignObjective} />
        )}
      </Step>
    )
  } else {
    return (
      <Step stepTitle="" handleContinue={handleContinue}>
        <CpaAdvancedSettings
          formik={formik}
          goalOptions={options}
          campaignObjective={campaignObjective}
          showInSpoiler={false}
          isOptional={false}
        />
      </Step>
    )
  }
}

export default OptimizationGoalAndBiddingStep
